import { createSubsetSelector } from 'webui/utils/selectors';
export const vehicle_controls_state = createSubsetSelector([
    'guard_state',
    'guard_state__loading',
    'guard_state__fail',
    'siren',
    'siren__loading',
    'siren__fail',
    'engine_block',
    'engine_block__loading',
    'engine_block__fail',
    'webasto',
    'webasto__loading',
    'webasto__fail',
    'auto_ignition',
    'auto_ignition__loading',
    'auto_ignition__fail',
    'action_fail_message',
]);
export const vehicle_controls_config = createSubsetSelector([
    'id',
    'capabilities',
    'auto_ignition_duration',
]);
